<template>
  <div v-if="getTypeById(exception.type)">
    <v-tooltip
      bottom
      :color="getTypeById(exception.type).color +' darken-2'"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-alert
          :color="getTypeById(exception.type).color +' darken-1'"
          dark
          dense
          class="text-center ma-0 pa-0"
          v-bind="attrs"
          v-on="on"
          @contextmenu="showContexMenu"
        >
          <v-icon v-if="getTypeById(exception.type).icon">{{ getTypeById(exception.type).icon}}</v-icon>
          <div
            v-if="!getTypeById(exception.type).icon"
            class="text-truncate text-caption"
            style="max-width:80px;margin:3px auto;"
          >{{exception.description}}</div>
        </v-alert>
      </template>
      <p class="font-weight-bold text-center">{{ getTypeById(exception.type).text }}</p>
      <p class="mb-0 text-center">{{exception.description}}</p>
      <v-menu
        v-model="contexMenu"
        :position-x="contexMenuPositionX"
        :position-y="contexMenuPositionY"
        absolute
        offset-y
        v-if="CURRENT_USER.id === exception.user.id || $acl.check('admin')"
      >
        <v-list dense min-width="150" class="pa-0">
          <v-list-item @click="deleteException">
            <v-list-item-icon>
              <v-icon>delete</v-icon>
            </v-list-item-icon>
            <v-list-item-content>usuń</v-list-item-content>
          </v-list-item>
        </v-list>
      </v-menu>
    </v-tooltip>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "CalendarExceptionCell",
  props: ["exception"],
  data: () => ({
    loading: false,
    contexMenu: false,
    contexMenuPositionY: null,
    contexMenuPositionX: null,
  }),
  components: {},
  computed: {
    ...mapGetters(["USER_WORK_SCHEDULE_EXCEPTION_TYPES"]),
    ...mapGetters(["CURRENT_USER"]),
  },
  mounted() {
  
  },
  methods: {
    getTypeById(id) {
      const element = this.USER_WORK_SCHEDULE_EXCEPTION_TYPES.find(
        (type) => type.value == id
      );
      return element;
    },
    deleteException(){
      this.loading = true;
      this.$store
        .dispatch("REMOVE_USER_WORK_SCHEDULE_EXCEPTION", {
          userWorkScheduleException: this.exception,
        })
        .then(() => {
          this.loading = false;
          this.$emit('deleted');
        });
    },
    showContexMenu(e) {
        e.preventDefault()
        this.contexMenu = false
        this.contexMenuPositionX = e.clientX
        this.contexMenuPositionY = e.clientY
        this.$nextTick(() => {
          this.contexMenu = true
        })
      },
  },
  watch: {},
};
</script>


<style>
</style>